import React from "react";
import {BottomNavigationBarMenuItemsListBox} from "./boxes/menu-items-list/bottom-navigation-bar-menu-items-list.box";
import {IMenuItemRenderer} from "../../services/menu-items-common/renderer/menu-item.renderer.interface";
import {CyClass} from "../../../common/cy-classes";
import {useServices} from "../../react-hooks/use-services.hook";


export const BottomNavigationBarMenuItemsListComponent: React.FC = () => {

    const services = useServices();

    const _renderMenuItem = (menuItem: IMenuItemRenderer) => {

        return (
            <React.Fragment key={menuItem.key}>
                {menuItem.renderMenuItem()}
            </React.Fragment>
        );
    }

        const menuItems = services.bottomNavigationBar.getMenuItems();

        if(menuItems.length === 0) {
            return null;
        }
        return (
            <React.Fragment>
                <BottomNavigationBarMenuItemsListBox className={CyClass('cy-hybrid-embedded-nav-menu-list')}>
                    {menuItems.map(menuItem => _renderMenuItem(menuItem))}
                </BottomNavigationBarMenuItemsListBox>
            </React.Fragment>
        );
}
